export const environment = {
    production: false,
    apiProfile: '/api/v1/users/whoami',
    apiLogout: '/api/v1/auth/logout',


    PERMISSIONS:  {
        STUDIES_APP: "study_management.studies_list",
        CONF_APP: "enclave_config.view_config",
        INBOX_APP: "inbox.view_inbox",
        DATA_INGRESS: "data_ingestion.view_ingress_module",
        DATA_CATALOG: "data_catalog.view_catalog_module",
        CREATE_STUDY: "study_management.create_study",
        STUDY_DETAILS: "study_details.view_study_details",
        STUDY_WBS_DETAILS: "study_details.view_wbs_code",        

        DATA_INGRESS_UPLOAD_FILE:"data_ingestion.upload_files",

        STUDY_ANALYTICS: "study_analytics.view_analytics_module",
        STUDY_ANALYTICS_ACCESS_HPC: "study_analytics.access_hpc",
        STUDY_ANALYTICS_MANAGE_EC2_JPY_SELF: "study_analytics.manage_ec2_jupyter_instance_self",
        STUDY_ANALYTICS_MANAGE_EC2_JPY_OTHERS: "study_analytics.manage_ec2_jupyter_instance_others",
        STUDY_ANALYTICS_SAGEMAKER: "study_analytics.access_sagemaker_apps",
        STUDY_ANALYTICS_CLOUD9: "study_analytics.access_cloud9",
        STUDY_ANALYTICS_NFT_MAINTAIN: "study_analytics.nft_maintain_role",
        STUDY_ANALYTICS_NFT_LAUNCH: "study_analytics.nft_launch_role",
        STUDY_ANALYTICS_HO_CREATE: "study_analytics.health_omics_create_run_workflow",
        STUDY_ANALYTICS_HO_RUN: "study_analytics.health_omics_run_workflow",
        STUDY_ANALYTICS_POSIT: "study_analytics.access_posit",
        STUDY_ANALYTICS_MANAGE_HPC: "study_analytics.manage_hpc",
        STUDY_ANALYTICS_CUSTOM_HPC:"study_analytics.create_custom_hpc",
        STUDY_ANALYTICS_EC2_LARGE_SIZE: "study_analytics.ec2_large_size_instance",
        STUDY_ANALYTICS_EC2_START_STOP_TERMINATE_BY_OTHERS:"study_analytics.ec2_start_stop_terminate",
        STUDY_ANALYTICS_JPY_START_STOP_TERMINATE_BY_OTHERS:"study_analytics.jupyter_start_stop_terminate",
        STUDY_MEMBERS: "study_members.view_members",
        STUDY_MEMBERS_INVITE: "study_members.invite_member",
        STUDY_MEMBERS_EDIT:"study_members.edit_member",
        STUDY_MEMBERS_REMOVE: "study_members.remove_member",
        STUDY_BUDGET: "study_budget.study_budget_module",
        STUDY_BUDGET_EDIT: "study_budget.view_edit_study_budget",
        
        CATALOGUE_SEARCH: "data_catalog.search_catalog",
        CATALOGUE_EDIT_METADATA:"data_catalog.edit_metadata",
        
        STUDY_SETTINGS: "settings.settings_module",
        
        APP_HOSTING: "app_hosting.app_hosting_module",
        APP_HOSTING_MANAGE:"app_hosting.manage_application",
    },
    ENC_ADMIN: 'ADMIN',
    ENC_CONF: {
        NFT: 'nft',
        ANALYTICS: 'analytics',
        OMICS:'health_omics',
        POSIT_CONNECT: 'posit_connect',
        SAGE_MAKER:  'sageMakerApps',
        SAGE_MAKER_WITH_JUPYTER: 'sageMakerWithJupyter',
        HPC: 'hpc',
        FSX: 'fsx',
        SENTIEON: 'sentieonLicense',
        BYOPCLOUD9: 'byopAndCloud9',
        CODEARTIFACT: 'codeArtifact',
        CODECOMMIT: 'codeCommit',
        ECR: 'ecr',
        ROCS: 'rocs',
        COMPUTE: 'compute',
        ENC_BASE: 'enclave_base',
        STATUS_CONFIGURED: 'CREATED',
        STATUS_INPROGRESS: 'INPROGRESS',
        STATUS_NOT_CONFIGURED: 'NO',
        STATUS_EDIT_IN_PROGRESS: 'EDITINPROGRESS',
        STATUS_EDIT_FAILED: 'EDITFAILED',
        STATUS_FAILED:'FAILED',
        WBS: 'wbs'
    },
    STUDY: {
        STATUS_CREATED: 'CREATED',
        STATUS_INPROGRESS: 'INPROGRESS',
        STATUS_FAILED: 'FAILED'
    },

    enclaveDetails: 'enclave-base-management-service/api/v1/enclave',
    enclavePutAPI: 'enclave-base-management-service/api/v1/enclaves',
    configApi: 'enclave-base-management-service/api/v1/enclave/appconfig/config',
    configFeatureApi: 'enclave-base-management-service/api/v1/enclave/appconfig/features',
    featureApi: 'enclave-base-management-service/api/v1/enclave/feature',
    deleteFeatureApi: 'enclave-base-management-service/api/v1/enclave/feature',
    permissionsAPi: 'enclave-base-user-management-service/api/v1/enclave/permissions',
    rolesApi: 'enclave-base-user-management-service/api/v1/enclave/role',
    ingressApi: 'enclave-base-data-ingestion-service/api/v1/datasets',
    downloadSchema: 'enclave-base-data-ingestion-service/api/v1/schema/download/template',
    downloadTemplate: 'enclave-base-data-ingestion-service/api/v1/schema/download',
    updateUser: 'enclave-base-user-management-service/api/v1/enclave/user/entry',
    
    validateStudyApi: "enclave-base-study-management-service/api/v1/study/validate",
    ingressSchemaApi:"enclave-base-data-ingestion-service/api/v1/schema",
    nftLogin: "enclave-base-study-management-service/api/v1/nftlogin",
    sFTPURL: "enclave-base-study-management-service/api/v1/study/infra/resourcedetail/",

    dataset: 'enclave-base-data-ingestion-service/api/v1/dataset',
    addFiles: 'enclave-base-data-ingestion-service/api/v1/dataset/file',
    listFiles: "enclave-base-data-ingestion-service/api/v1/sftpfiles",
    dataIngressFileUpload: 'enclave-base-data-ingestion-service/api/v1/filemanagement/upload',
    dataIngressCompleteMultiPart: 'enclave-base-data-ingestion-service/api/v1/filemanagement/completeupload',
    saveIngress: "enclave-base-data-ingestion-service/api/v1/dataset/metadata",
    dataIngressGetMetadata:"enclave-base-data-ingestion-service/api/v1/dataset",
    inbox:"enclave-base-data-ingestion-service/api/v1/inboxmanagement/inbox",
    analyticsInstance: "enclave-base-study-management-service/api/v1/study",
    instarnceSize: "enclave-base-management-service/api/v1/enclave/config",
    fileUploadForMetadata: "enclave-base-data-ingestion-service/api/v1/dataset/uploadnewschema",
    analyticsInstanceLaunch: 'studyinternal/enclave-base-study-management-service/api/v1/study',
    analyticsPagePermission:'enclave-base-management-service/api/v1/settings',
    configPage:'enclave-base-management-service/api/v1/settings/master',
    getConfigPageDetails: 'enclave-base-management-service/api/v1/settings/master/enclave',
    verifyReferenceTypeID: "enclave-base-data-ingestion-service/api/v1/dataset/metadata/verify",
    getSchemaForExistingIngress: "enclave-base-data-ingestion-service/api/v1/dataset/metadata",
    jupyterInstance: "enclave-base-study-management-service/api/v1/manageJupyterInstance",


    inviteNewMemberApi:"enclave-base-user-management-service/api/v1/enclave/user/invite",
    inviteExistingMemberApi:"enclave-base-user-management-service/api/v1/enclave/users",
    memberDetailsByEmailApi:"enclave-base-user-management-service/api/v1/email",
    viewMemberApi:"enclave-base-user-management-service/api/v1/enclave/study/members",
    membersListApi:"enclave-base-user-management-service/api/v1/users/ENCLAVE",
    editMemberApi:"enclave-base-user-management-service/api/v1/enclave/user",
    excludeCurrentroleApi:"enclave-base-user-management-service/api/v1/enclave/study/role",
    getRoleByType:"enclave-base-user-management-service/api/v1/enclave/role/roleType",
    
    rolePermissions: "enclave-base-user-management-service/api/v1/enclave/user/rolepermission",

    sfTPDetails: "enclave-base-security-service/api/v1/detail",

    catalogueDetails: "enclave-base-catalog-service/api/v1/publish/customsearch",

    csiDetails: 'enclave-base-study-management-service/api/v1/csi',

    supportedApp: 'enclave-base-study-management-service/api/v1/study/supportedapp',
    installedApp: 'enclave-base-study-management-service/api/v1/study/installedapp',
    databaseInformation: 'enclave-base-study-management-service/api/v1/study/appinfradetail',
    budget: "enclave-base-study-management-service/api/v1/budgets",
    budgetByStudy: "enclave-base-study-management-service/api/v1/budget/usage",
    costDashboard: "enclave-base-study-management-service/api/v1/costdashboard",
    updateBudget: "enclave-base-study-management-service/api/v1/study",

    oauth2Config: {
        authorizeUrl: 'https://api.appdevus.platform.navify.com/api/v1/auth/protocols/oidc/authorize',
        startUrl: 'enclave-base-security-service/api/auth/oauth2/start',
        exchangeUrl: 'enclave-base-security-service/api/auth/oauth2/exchange',
        refreshUrl: 'enclave-base-security-service/api/auth/oauth2/refresh',
        logoutUrl: 'enclave-base-security-service/api/auth/oauth2/logout',
        autoTriggerOnLogin: true
    },
    userManualApi: "enclave-base-management-service/api/v1/enclave/config/userManual/contents",

};

